/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { ContractAllocationForClaimResponseDto } from './ContractAllocationForClaimResponseDto';
import {
    ContractAllocationForClaimResponseDtoFromJSON,
    ContractAllocationForClaimResponseDtoFromJSONTyped,
    ContractAllocationForClaimResponseDtoToJSON,
    ContractAllocationForClaimResponseDtoToJSONTyped,
} from './ContractAllocationForClaimResponseDto';

/**
 * 
 * @export
 * @interface ContractAllocationForClaimPaginationResponseDto
 */
export interface ContractAllocationForClaimPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ContractAllocationForClaimPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ContractAllocationForClaimResponseDto>}
     * @memberof ContractAllocationForClaimPaginationResponseDto
     */
    items: Array<ContractAllocationForClaimResponseDto>;
}

/**
 * Check if a given object implements the ContractAllocationForClaimPaginationResponseDto interface.
 */
export function instanceOfContractAllocationForClaimPaginationResponseDto(value: object): value is ContractAllocationForClaimPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ContractAllocationForClaimPaginationResponseDtoFromJSON(json: any): ContractAllocationForClaimPaginationResponseDto {
    return ContractAllocationForClaimPaginationResponseDtoFromJSONTyped(json, false);
}

export function ContractAllocationForClaimPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractAllocationForClaimPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ContractAllocationForClaimResponseDtoFromJSON)),
    };
}

export function ContractAllocationForClaimPaginationResponseDtoToJSON(json: any): ContractAllocationForClaimPaginationResponseDto {
    return ContractAllocationForClaimPaginationResponseDtoToJSONTyped(json, false);
}

export function ContractAllocationForClaimPaginationResponseDtoToJSONTyped(value?: ContractAllocationForClaimPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ContractAllocationForClaimResponseDtoToJSON)),
    };
}

